import { ProductListFilter } from '../models';
import { defaultTablePageSize } from '~/common/components/consts';

export const setDefaultPaginate = (params: any) => {
  const _params = typeof params !== 'object' ? {} : params;

  if (typeof _params.offset !== 'number') params.offset = 0;
  if (typeof _params.limit !== 'number') params.limit = defaultTablePageSize;

  return _params
};

export function addProductsFilter(qs: any, filter: ProductListFilter) {
  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }
  }

  return qs;
}
